const searchQuery = window.location.href.split("q=")[1];

window.scrollDown = async ($data) => {
  let collectionGridElement = document.querySelector(
    "#collection-grid-container.has-products"
  );
  if ($data.last) return;
  $data.page++;

  console.log('on page:', $data.page, $data);

  const section = searchQuery ? "main-search" : "main-collection-product-grid";
  // const section = "main-collection-product-grid-new";
  const myDiv = document.createElement("div");

  const nextSectionResponse = searchQuery
    ? await fetch(
        `${window.location.pathname}?page=${$data.page}&q=${searchQuery}&sections=${section}`
      )
    : await fetch(
        `${window.location.pathname}?page=${$data.page}&sections=${section}`
      );

  myDiv.innerHTML = (await nextSectionResponse.json())[section];
  const children = myDiv.querySelector("#collection-grid-container").children;
  if (!children.length) $data.last = true;

  const existingIds = new Set(
    [...collectionGridElement.querySelectorAll('[data-product-id]')]
    .map(el => el.getAttribute('data-product-id'))
  );

  [...children].forEach((i) => {
    const newId = i.getAttribute('data-product-id');
    if (!newId || !existingIds.has(newId)) {
      collectionGridElement.appendChild(i);
      if (newId) existingIds.add(newId);
    }
  });

  window.initLazy("#collection-grid-container img[data-lazy]:not([src])");
};
